/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports =  {
  "sitecoreApiKey": "{71FEFFB9-6CAA-4009-9F5C-EEAA63F3A94C}",
  "sitecoreApiHost": "",
  "jssAppName": "dotsite",
  "defaultLanguage": "en",
  "defaultLanguageName": "English",
  "defaultFontSize": "z100",
  "defaultContrast": "theme1"
};